import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from './icons';

interface CartIconProps {
  count: number;
  onClick: () => void;
  className?: string;
}

export function CartIcon({ count, onClick, className = '' }: CartIconProps) {
  return (
    <button
      onClick={onClick}
      className={`relative p-2 rounded-full hover:bg-brand-gold/10 transition-colors ${className}`}
      aria-label={`Cart with ${count} items`}
    >
      <ShoppingBagIcon size={24} className="text-brand-gold" />
      <AnimatePresence>
        {count > 0 && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-brand-gold text-white text-xs font-medium flex items-center justify-center"
          >
            {count > 99 ? '99+' : count}
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  );
}
